import { render, staticRenderFns } from "./CardFull.vue?vue&type=template&id=43cc621a&scoped=true"
import script from "./CardFull.vue?vue&type=script&lang=js"
export * from "./CardFull.vue?vue&type=script&lang=js"
import style0 from "./CardFull.vue?vue&type=style&index=0&id=43cc621a&prod&lang=css"
import style1 from "./CardFull.vue?vue&type=style&index=1&id=43cc621a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "43cc621a",
  null
  
)

export default component.exports